// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__R2ljF","Footer__Section":"Footer_Footer__Section__QIbi2","Footer__Footnote":"Footer_Footer__Footnote__SjPCj"};